import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "@features/auth/contexts/AuthContext";
import { RouterProvider } from "react-router-dom";
import { router } from "@/routes/routes";
import { ThemeProvider } from "@shared/contexts/ThemeProvider";
import { LanguageWrapper } from "@shared/components/LanguageSwitcher";
import ToastProvider from "@shared/components/ToastProvider";

import SettingsProvider from "@shared/contexts/SettingContext";

const queryClient = new QueryClient();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <LanguageWrapper>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <SettingsProvider>
            <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
              <RouterProvider router={router} />
            </ThemeProvider>
            <ToastProvider />
          </SettingsProvider>
        </AuthProvider>
      </QueryClientProvider>
    </LanguageWrapper>
  </StrictMode>
);
